export default "__VITE_ASSET__D08b9sT5__"